
import { gql } from '@apollo/client';

export const UPDATE_SELLER_PROFILE = gql`
  mutation UpdateSellerProfile($input: SellerProfileInput!) {
    updateSellerProfile(input: $input) {
      success
      message
      data {
        seller_id
        email
        banner_pic
        logo_pic
        sid
        created_at
        updated_at
        contact_number
        company_locality
        shop_title
        company_description
        return_policy
        shipping_policy
      }
    }
  }
`;
